import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'

import {
    RateCardsValues,
} from './RateCards.types'
import baseLeaseConfig from './BaseLease/BaseLease.config'
import embargoCountriesConfig from './EmbargoCountries/EmbargoContries.config'
import otherLaneFeesConfig from './OtherLaneFees/OtherLaneFees.config'
import additionalFeesConfig from './AdditionalFees/AdditionalFees.config'
import marginsConfig from './Margins/Margins.config'
import logisticsCostsConfig from './LogisticsCosts/LogisticsCosts.config'
import regionalServiceAvailabilityConfig from './RegionalServiceAvailability/RegionalServiceAvailability.config'

const config: SkyNetTableConfig<keyof RateCardsValues> = {
    name: 'RateCards',
    tabs: [
        baseLeaseConfig,
        otherLaneFeesConfig,
        additionalFeesConfig,
        marginsConfig,
        logisticsCostsConfig,
        regionalServiceAvailabilityConfig,
        embargoCountriesConfig,
    ],
}

export default config
